// extracted by mini-css-extract-plugin
export default {"step":"styles_step__vKTtn","groupTitle":"styles_groupTitle__t5Bs4","fadein":"styles_fadein__nK311"};